import React, { createContext, useContext, useState } from 'react';
import Modal from './Modal';

const ConfirmContext = createContext();

export const useConfirm = () => useContext(ConfirmContext);

const ConfirmProvider = ({ children }) => {
  const [confirmState, setConfirmState] = useState({
    visible: false,
    message: '',
    resolve: null,
    alert: false,
  });

  const confirm = (message, alert) => {
    return new Promise((resolve) => {
      setConfirmState({ visible: true, message, resolve, alert });
    });
  };

  const handleYes = () => {
    confirmState.resolve(true);
    setConfirmState({ ...confirmState, visible: false });
  };

  const handleNo = () => {
    confirmState.resolve(false);
    setConfirmState({ ...confirmState, visible: false });
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {confirmState.visible && (
        <Modal isOpen={true} zIndex={200}>
          <div style={{
                 background: 'linear-gradient(gray, transparent)',
                 position: 'absolute',
                 transform: 'translate(-50%, -50%)',
                 top: '50%',
                 left: '50%',
                 width: 'fit-content',
                 borderRadius: '10px',
               }}>
            <div
              style={{
                margin: '1px',
                borderRadius: '10px',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                padding: '20px',
                backgroundColor: 'black',
              }}>
              <div style={{
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'center',
                     justifyContent: 'space-between',
                     width: '100%',
                     gap: '20px',
                   }}>
                <span style={{fontSize: '22px',
                              fontWeight: 'bold',
                              color: 'white'
                             }}>
                  {confirmState.message}
                </span>

                <div style={{display: 'flex',
                             flexDirection: 'row',
                             alignItems: 'center',
                             marginTop: '10px',
                             gap: '10px',
                             justifyContent: 'center',
                            }}>
                  {confirmState.alert && (
                    <div style={{alignItems: 'center',
                                 padding: '10px 20px',
                                 backgroundColor: '#009de6',
                                 color: 'white',
                                 borderRadius: '5px',
                                 cursor: 'pointer',
                                 fontWeight: 'bold',
                                 alignSelf: 'flex-end',
                                 display: 'flex',
                                 justifyContent: 'center',
                                }}
                         onClick={handleYes}>
                      Ok
                    </div>
                  )}

                  {!confirmState.alert && (
                    <>
                      <div style={{alignItems: 'center',
                                   padding: '10px 20px',
                                   border: '1px solid #e0e0e0',
                                   borderRadius: '5px',
                                   cursor: 'pointer',
                                   fontWeight: 'bold',
                                   alignSelf: 'flex-end',
                                   display: 'flex',
                                   justifyContent: 'center',
                                   color: 'white'
                                  }}
                           onClick={handleNo}>
                        No
                      </div>
                      <div style={{alignItems: 'center',
                                   padding: '10px 20px',
                                   backgroundColor: '#009de6',
                                   color: 'white',
                                   borderRadius: '5px',
                                   cursor: 'pointer',
                                   fontWeight: 'bold',
                                   alignSelf: 'flex-end',
                                   display: 'flex',
                                   justifyContent: 'center',
                                  }}
                           onClick={handleYes}>
                        Yes
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </ConfirmContext.Provider>
  );
};

export default ConfirmProvider;
